if (!customElements.get('product-modal')) {
  // How much the full-screen viewer image scales on click-to-zoom.
  const MODAL_ZOOM = 2.2;

  // Pan the zoomed image so the area under the cursor stays in view.
  const panModalImage = (image, event) => {
    const rect = image.zoomBaseRect || image.getBoundingClientRect();
    let x = (event.clientX - rect.left) / rect.width;
    let y = (event.clientY - rect.top) / rect.height;
    x = Math.max(0, Math.min(1, x));
    y = Math.max(0, Math.min(1, y));
    image.style.transformOrigin = `${x * 100}% ${y * 100}%`;
  };

  const resetModalZoom = (image) => {
    image.classList.remove('is-zoomed');
    image.style.transform = '';
    image.style.transformOrigin = '';
  };

  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.setupNavigation();
        this.setupZoom();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.querySelectorAll('.product-media-modal__content > img.is-zoomed').forEach(resetModalZoom);
        this.showActiveMedia();
      }

      // Wire up the prev/next arrows so the viewer shows one image at a time.
      setupNavigation() {
        this.querySelectorAll('.product-media-modal__nav').forEach((button) => {
          // Stop the click from bubbling to the media-modal close handler (pointerup).
          button.addEventListener('pointerup', (event) => event.stopPropagation());
          button.addEventListener('click', (event) => {
            event.preventDefault();
            const direction = button.classList.contains('product-media-modal__nav--next') ? 1 : -1;
            this.showSiblingMedia(direction);
          });
        });
      }

      // Click the image to zoom in / out; move the cursor to pan while zoomed.
      setupZoom() {
        this.querySelectorAll('.product-media-modal__content > img').forEach((image) => {
          if (image.dataset.zoomReady === 'true') return;
          image.dataset.zoomReady = 'true';

          // Keep an image click from bubbling to the media-modal click-to-close.
          image.addEventListener('pointerup', (event) => event.stopPropagation());

          image.addEventListener('click', (event) => {
            event.stopPropagation();
            if (image.classList.contains('is-zoomed')) {
              resetModalZoom(image);
            } else {
              image.zoomBaseRect = image.getBoundingClientRect();
              image.classList.add('is-zoomed');
              image.style.transform = `scale(${MODAL_ZOOM})`;
              panModalImage(image, event);
            }
          });

          image.addEventListener('mousemove', (event) => {
            if (image.classList.contains('is-zoomed')) panModalImage(image, event);
          });

          image.addEventListener('mouseleave', () => resetModalZoom(image));
        });
      }

      // Move the `active` media to the next/previous one (wraps around).
      showSiblingMedia(direction) {
        const mediaItems = Array.from(this.querySelectorAll('.product-media-modal__content > [data-media-id]'));
        if (mediaItems.length < 2) return;

        const current = this.querySelector('.product-media-modal__content > .active[data-media-id]');
        const currentIndex = current ? mediaItems.indexOf(current) : 0;
        const nextIndex = (currentIndex + direction + mediaItems.length) % mediaItems.length;
        const nextMedia = mediaItems[nextIndex];

        mediaItems.forEach((element) => {
          element.classList.remove('active');
          if (element.tagName === 'IMG') resetModalZoom(element);
        });
        nextMedia.classList.add('active');
        nextMedia.scrollIntoView({ block: 'nearest' });

        const template = nextMedia.querySelector('template');
        if (nextMedia.nodeName === 'DEFERRED-MEDIA' && template && template.content.querySelector('.js-youtube')) {
          nextMedia.loadContent();
        }
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
